import { render, staticRenderFns } from "./ManageButton.vue?vue&type=template&id=a4fc847c&scoped=true&"
import script from "./ManageButton.vue?vue&type=script&lang=js&"
export * from "./ManageButton.vue?vue&type=script&lang=js&"
import style1 from "./ManageButton.vue?vue&type=style&index=1&id=a4fc847c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fc847c",
  null
  
)

export default component.exports